module.exports = __webpack_public_path__ + "static/sram-logo-58e8e9e06d92077dcf6a29ecb148fe37.png";